import React, { useState, useEffect, useCallback } from 'react';
import {
    Table,
    Card,
    Input,
    Button,
    Select,
    Space,
    Tag,
    Typography,
    Empty,
    Alert,
    Form,
    Skeleton,
    Drawer,
} from 'antd';
import {
    SearchOutlined,
    ReloadOutlined,
    CopyOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

// ══════════════════════════════════════════════
//  Mock 数据 — TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

const MOCK_LICENSES = [
    { license: 'test-lic-001-20260501', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '深圳产线A批次', orderId: 'WO-2026-001', activeStatus: 'activated', activeTime: '2026-06-15 14:30:00', createdAt: '2026-05-01 10:00:00' },
    { license: 'test-lic-002-20260501', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '深圳产线A批次', orderId: 'WO-2026-001', activeStatus: 'activated', activeTime: '2026-06-16 09:15:00', createdAt: '2026-05-01 10:00:05' },
    { license: 'test-lic-003-20260501', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-05-01 10:00:10' },
    { license: 'test-lic-004-20260428', productName: '智能门磁 S1', productId: 'PID-5510', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '门磁试产批次', orderId: 'WO-2026-005', activeStatus: 'activated', activeTime: '2026-05-10 11:00:00', createdAt: '2026-04-28 08:00:00' },
    { license: 'test-lic-005-20260428', productName: '智能门磁 S1', productId: 'PID-5510', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-04-28 08:00:05' },
    { license: 'test-lic-006-20260428', productName: '智能门磁 S1', productId: 'PID-5510', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '门磁试产批次', orderId: 'WO-2026-005', activeStatus: 'activated', activeTime: '2026-06-01 08:20:00', createdAt: '2026-04-28 08:00:08' },
    { license: 'test-lic-007-20260415', productName: '可视门铃 Pro', productId: 'PID-7723', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'produced', orderName: '华东批量生产', orderId: 'WO-2026-008', activeStatus: 'activated', activeTime: '2026-05-20 16:45:00', createdAt: '2026-04-15 09:00:00' },
    { license: 'test-lic-008-20260415', productName: '可视门铃 Pro', productId: 'PID-7723', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'produced', orderName: '华东批量生产', orderId: 'WO-2026-008', activeStatus: 'inactive', activeTime: null, createdAt: '2026-04-15 09:00:10' },
    { license: 'test-lic-009-20260415', productName: '可视门铃 Pro', productId: 'PID-7723', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-04-15 09:00:15' },
    { license: 'test-lic-010-20260510', productName: '烟雾报警器 NB-IoT', productId: 'PID-1155', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'produced', orderName: '安防产品线', orderId: 'WO-2026-012', activeStatus: 'activated', activeTime: '2026-06-01 12:00:00', createdAt: '2026-05-10 11:00:00' },
    { license: 'test-lic-011-20260510', productName: '智能插座 WIFI', productId: 'PID-8821', companyName: '北京智联科技有限公司', companyId: 'ENT003', produceStatus: 'produced', orderName: null, orderId: null, activeStatus: 'activated', activeTime: '2026-06-03 10:20:00', createdAt: '2026-05-10 11:00:10' },
    { license: 'test-lic-012-20260510', productName: '智能插座 WIFI', productId: 'PID-8821', companyName: '北京智联科技有限公司', companyId: 'ENT003', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-05-10 11:00:15' },
    { license: 'test-lic-013-20260510', productName: '智能插座 WIFI', productId: 'PID-8821', companyName: '北京智联科技有限公司', companyId: 'ENT003', produceStatus: 'produced', orderName: '插座量产线1号', orderId: 'WO-2026-018', activeStatus: 'activated', activeTime: '2026-06-10 07:30:00', createdAt: '2026-05-10 11:00:20' },
    { license: 'test-lic-014-20260301', productName: '智能灯带 RGB', productId: 'PID-6678', companyName: '广州光电科技有限公司', companyId: 'ENT004', produceStatus: 'produced', orderName: '灯带量产批次1', orderId: 'WO-2026-015', activeStatus: 'activated', activeTime: '2026-04-05 18:30:00', createdAt: '2026-03-01 14:00:00' },
    { license: 'test-lic-015-20260301', productName: '智能灯带 RGB', productId: 'PID-6678', companyName: '广州光电科技有限公司', companyId: 'ENT004', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-03-01 14:00:15' },
    { license: 'test-lic-016-20260301', productName: '智能窗帘电机', productId: 'PID-9901', companyName: '广州光电科技有限公司', companyId: 'ENT004', produceStatus: 'produced', orderName: '智能家居产线', orderId: 'WO-2026-020', activeStatus: 'activated', activeTime: '2026-04-20 15:45:00', createdAt: '2026-03-01 14:00:20' },
    { license: 'test-lic-017-20260320', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '深圳产线A批次', orderId: 'WO-2026-001', activeStatus: 'activated', activeTime: '2026-05-12 09:00:00', createdAt: '2026-03-20 16:00:00' },
    { license: 'test-lic-018-20260320', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-03-20 16:00:05' },
    { license: 'test-lic-019-20260320', productName: '智能灯带 RGB', productId: 'PID-6678', companyName: '广州光电科技有限公司', companyId: 'ENT004', produceStatus: 'produced', orderName: '灯带量产批次2', orderId: 'WO-2026-025', activeStatus: 'activated', activeTime: '2026-05-18 11:30:00', createdAt: '2026-03-20 16:00:10' },
    { license: 'test-lic-020-20260520', productName: '温湿度传感器', productId: 'PID-4432', companyName: '北京智联科技有限公司', companyId: 'ENT003', produceStatus: 'produced', orderName: '传感器产线', orderId: 'WO-2026-030', activeStatus: 'inactive', activeTime: null, createdAt: '2026-05-20 09:00:00' },
    { license: 'test-lic-021-20260520', productName: '温湿度传感器', productId: 'PID-4432', companyName: '北京智联科技有限公司', companyId: 'ENT003', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-05-20 09:00:05' },
    { license: 'test-lic-022-20260520', productName: '智能门磁 S1', productId: 'PID-5510', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '门磁试产批次', orderId: 'WO-2026-005', activeStatus: 'activated', activeTime: '2026-06-08 14:00:00', createdAt: '2026-05-20 09:00:10' },
    { license: 'test-lic-023-20260601', productName: '智能摄像头 Pro', productId: 'PID-3382', companyName: '深圳智创科技有限公司', companyId: 'ENT001', produceStatus: 'produced', orderName: '深圳产线A批次', orderId: 'WO-2026-001', activeStatus: 'inactive', activeTime: null, createdAt: '2026-06-01 10:00:00' },
    { license: 'test-lic-024-20260601', productName: '可视门铃 Pro', productId: 'PID-7723', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'produced', orderName: '华东批量生产', orderId: 'WO-2026-008', activeStatus: 'activated', activeTime: '2026-06-12 16:30:00', createdAt: '2026-06-01 10:00:05' },
    { license: 'test-lic-025-20260601', productName: '烟雾报警器 NB-IoT', productId: 'PID-1155', companyName: '杭州万物互联有限公司', companyId: 'ENT002', produceStatus: 'pending', orderName: null, orderId: null, activeStatus: 'inactive', activeTime: null, createdAt: '2026-06-01 10:00:10' },
];

// 产品列表（远端搜索模拟）
const ALL_PRODUCTS = [...new Map(MOCK_LICENSES.map(item => [item.productId, { productName: item.productName, productId: item.productId }])).values()];

// 工单列表（远端搜索模拟）
const ALL_ORDERS = [...new Map(
    MOCK_LICENSES.filter(item => item.orderName).map(item => [item.orderId, { orderName: item.orderName, orderId: item.orderId }])
).values()];

// 企业列表（远端搜索模拟，平台角色专用）
const ALL_ENTERPRISES = [...new Map(MOCK_LICENSES.map(item => [item.companyId, { companyName: item.companyName, companyId: item.companyId }])).values()];

// 整机产品 → 所属方案产品（无方案则不在此表）
const PLAN_BY_PRODUCT = {
    'PID-3382': { name: '智能云台摄像机方案', id: 'P_ECO_001' },
    'PID-7723': { name: '智能门铃方案', id: 'P_ECO_003' },
};

// 状态映射
const PRODUCE_STATUS_MAP = {
    produced: { text: '已生产', color: 'green' },
    pending: { text: '待生产', color: 'orange' },
};

// ══════════════════════════════════════════════
//  设备归属变更记录（Mock）— TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

const OWNERSHIP_RESULT_MAP = {
    success: { text: '成功', color: 'success' },
    failed: { text: '失败', color: 'error' },
};

const MOCK_OWNERSHIP_CHANGES = [
    { license: 'test-lic-001-20260501', planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001', machineProductName: '智能摄像头-万物标准版', machineProductId: 'P_DRV_001', machineCompanyName: '杭州万物互联有限公司', machineCompanyId: 'ENT002', changedAt: '2026-05-02 10:00:00', sourceType: 'tool', workOrderName: '云台方案→万物标准版 改号', workOrderId: 'WO-CHG-101', operationNo: null, result: 'success', failReason: null },
    { license: 'test-lic-004-20260428', planProductName: '智能云台摄像机方案', planProductId: 'P_ECO_001', machineProductName: '智能门磁-万物定制版', machineProductId: 'P_DRV_003', machineCompanyName: '杭州万物互联有限公司', machineCompanyId: 'ENT002', changedAt: '2026-05-06 15:30:00', sourceType: 'manual', workOrderName: null, workOrderId: null, operationNo: 'GH20260506153000123A01', result: 'success', failReason: null },
    { license: 'test-lic-014-20260301', planProductName: '智能灯带方案', planProductId: 'P_ECO_009', machineProductName: '智能窗帘电机', machineProductId: 'PID-9901', machineCompanyName: '广州光电科技有限公司', machineCompanyId: 'ENT004', changedAt: '2026-03-05 11:12:00', sourceType: 'tool', workOrderName: '灯带方案→窗帘电机 改号', workOrderId: 'WO-CHG-102', operationNo: null, result: 'failed', failReason: 'License 不属于所选方案产品' },
];

// ══════════════════════════════════════════════
//  主组件：LicenseQueryNew
// ══════════════════════════════════════════════

const LicenseQueryNew = () => {
    const [form] = Form.useForm();

    // 角色切换（原型演示）
    // TODO: 联调时通过登录态获取真实角色
    const [isPlatform, setIsPlatform] = useState(false);
    // 模拟：查询当前企业（原型用 ENT001）
    const CURRENT_ENTERPRISE_ID = 'ENT001';

    // 列表状态
    const [dataSource, setDataSource] = useState([]);
    const [total, setTotal] = useState(0);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const [initialLoaded, setInitialLoaded] = useState(false);

    // 筛选控件模式状态
    const [productMode, setProductMode] = useState('name');
    const [planMode, setPlanMode] = useState('name');
    const [orderMode, setOrderMode] = useState('name');
    const [enterpriseMode, setEnterpriseMode] = useState('name');

    // 远端搜索下拉选项
    const [productOptions, setProductOptions] = useState([]);
    const [orderOptions, setOrderOptions] = useState([]);
    const [enterpriseOptions, setEnterpriseOptions] = useState([]);

    // 远端搜索 loading
    const [productSearching, setProductSearching] = useState(false);
    const [orderSearching, setOrderSearching] = useState(false);
    const [enterpriseSearching, setEnterpriseSearching] = useState(false);

    // 筛选查询 loading
    const [searchLoading, setSearchLoading] = useState(false);

    // 归属变更历史抽屉
    const [ownershipOpen, setOwnershipOpen] = useState(false);
    const [ownershipLicense, setOwnershipLicense] = useState('');

    // ═══════════ 远端搜索处理 ═══════════

    const handleProductSearch = useCallback((keyword) => {
        setProductSearching(true);
        setTimeout(() => {
            const filtered = ALL_PRODUCTS.filter(
                p => !keyword || p.productName.toLowerCase().includes(keyword.toLowerCase())
            );
            setProductOptions(filtered.map(p => ({ value: p.productId, label: p.productName })));
            setProductSearching(false);
        }, 300);
    }, []);

    const handleOrderSearch = useCallback((keyword) => {
        setOrderSearching(true);
        setTimeout(() => {
            const filtered = ALL_ORDERS.filter(
                o => !keyword || o.orderName.toLowerCase().includes(keyword.toLowerCase())
            );
            setOrderOptions(filtered.map(o => ({ value: o.orderId, label: o.orderName })));
            setOrderSearching(false);
        }, 300);
    }, []);

    const handleEnterpriseSearch = useCallback((keyword) => {
        setEnterpriseSearching(true);
        setTimeout(() => {
            const filtered = ALL_ENTERPRISES.filter(
                e => !keyword || e.companyName.toLowerCase().includes(keyword.toLowerCase())
            );
            setEnterpriseOptions(filtered.map(e => ({ value: e.companyId, label: e.companyName })));
            setEnterpriseSearching(false);
        }, 300);
    }, []);

    // ═══════════ 数据过滤 + 分页 ═══════════

    const fetchData = useCallback((values, page = 1, pageSize = pagination.pageSize) => {
        setSearchLoading(true);

        // 模拟异步查询
        setTimeout(() => {
            let filtered = [...MOCK_LICENSES];

            // 企业角色：仅展示本企业数据
            if (!isPlatform) {
                filtered = filtered.filter(item => item.companyId === CURRENT_ENTERPRISE_ID);
            }

            // License 查询（模糊匹配）
            if (values.license && values.license.trim()) {
                const kw = values.license.trim().toLowerCase();
                filtered = filtered.filter(item => item.license.toLowerCase().includes(kw));
            }

            // 产品筛选
            if (values.productValue) {
                if (productMode === 'name') {
                    // 按产品 ID 筛选（select 的 value 是 productId）
                    filtered = filtered.filter(item => item.productId === values.productValue);
                } else {
                    // 按产品 ID 模糊匹配
                    const kw = values.productValue.toLowerCase();
                    filtered = filtered.filter(item => item.productId.toLowerCase().includes(kw));
                }
            }

            // 方案产品筛选
            if (values.planValue) {
                const kw = values.planValue.trim().toLowerCase();
                filtered = filtered.filter(item => {
                    const plan = PLAN_BY_PRODUCT[item.productId];
                    if (!plan) return false;
                    return planMode === 'id'
                        ? plan.id.toLowerCase().includes(kw)
                        : plan.name.toLowerCase().includes(kw);
                });
            }

            // 工单筛选
            if (values.orderValue) {
                if (orderMode === 'name') {
                    filtered = filtered.filter(item => item.orderId === values.orderValue);
                } else {
                    const kw = values.orderValue.toLowerCase();
                    filtered = filtered.filter(item => item.orderId && item.orderId.toLowerCase().includes(kw));
                }
            }

            // 企业筛选（仅平台角色）
            if (isPlatform && values.enterpriseValue) {
                if (enterpriseMode === 'name') {
                    filtered = filtered.filter(item => item.companyId === values.enterpriseValue);
                } else {
                    const kw = values.enterpriseValue.toLowerCase();
                    filtered = filtered.filter(item => item.companyId.toLowerCase().includes(kw));
                }
            }

            // 按创建时间倒序
            filtered.sort((a, b) => b.createdAt.localeCompare(a.createdAt));

            // 分页
            const start = (page - 1) * pageSize;
            const paged = filtered.slice(start, start + pageSize);

            setDataSource(paged);
            setTotal(filtered.length);
            setPagination({ current: page, pageSize });
            setSearchLoading(false);
            setInitialLoaded(true);
        }, 400);
    }, [isPlatform, productMode, planMode, orderMode, enterpriseMode, pagination.pageSize]);

    // ═══════════ 初始加载 ═══════════

    useEffect(() => {
        fetchData({}, 1, 20);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPlatform]);

    // ═══════════ 操作处理 ═══════════

    const handleSearch = () => {
        form.validateFields().then((values) => {
            fetchData(values, 1, pagination.pageSize);
        }).catch(() => {});
    };

    const handleReset = () => {
        form.resetFields();
        setProductMode('name');
        setPlanMode('name');
        setOrderMode('name');
        setEnterpriseMode('name');
        setProductOptions([]);
        setOrderOptions([]);
        setEnterpriseOptions([]);
        fetchData({}, 1, pagination.pageSize);
    };

    const handlePageChange = (page, pageSize) => {
        form.validateFields().then((values) => {
            fetchData(values, page, pageSize);
        }).catch(() => {});
    };

    const handleViewDevice = (license) => {
        window.open(`/device/info?license=${license}`, '_blank');
    };

    const handleViewOwnership = (license) => {
        setOwnershipLicense(license);
        setOwnershipOpen(true);
    };

    // 该 License 的归属变更链（按时间正序）
    const ownershipChain = MOCK_OWNERSHIP_CHANGES
        .filter((item) => item.license === ownershipLicense)
        .sort((a, b) => a.changedAt.localeCompare(b.changedAt));

    // ═══════════ 表格列定义 ═══════════

    const columns = [
        {
            title: 'License码',
            dataIndex: 'license',
            key: 'license',
            width: 200,
            render: (text) => (
                <Space>
                    <Text copyable={{ text, icon: <CopyOutlined style={{ fontSize: 12 }} /> }} style={{ fontFamily: 'monospace' }}>
                        {text}
                    </Text>
                </Space>
            ),
        },
        {
            title: '整机产品',
            dataIndex: 'productName',
            key: 'productInfo',
            width: 180,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{record.productName}</div>
                    <div>
                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>
                            {record.productId}
                        </Text>
                    </div>
                </div>
            ),
        },
        {
            title: '方案产品',
            key: 'plan',
            width: 180,
            render: (_, record) => {
                const plan = PLAN_BY_PRODUCT[record.productId];
                if (!plan) {
                    return <span style={{ color: '#ccc' }}>-</span>;
                }
                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{plan.name}</div>
                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{plan.id}</Text>
                    </div>
                );
            },
        },
    ];

    // 平台角色插入"企业信息"列
    if (isPlatform) {
        columns.push({
            title: '企业信息',
            dataIndex: 'companyName',
            key: 'companyInfo',
            width: 180,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{record.companyName}</div>
                    <div>
                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>
                            {record.companyId}
                        </Text>
                    </div>
                </div>
            ),
        });
    }

    // 后续公共列
    columns.push(
        {
            title: '生产状态',
            dataIndex: 'produceStatus',
            key: 'produceStatus',
            width: 100,
            render: (status) => {
                const config = PRODUCE_STATUS_MAP[status] || { text: status, color: 'default' };
                return <Tag color={config.color} style={{ border: 'none' }}>{config.text}</Tag>;
            },
        },
        {
            title: '所属工单',
            dataIndex: 'orderName',
            key: 'orderInfo',
            width: 180,
            render: (_, record) => {
                if (!record.orderName) {
                    return <span style={{ color: '#ccc' }}>—</span>;
                }
                return (
                    <div>
                        <div style={{ fontWeight: 500 }}>{record.orderName}</div>
                        <div>
                            <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>
                                {record.orderId}
                            </Text>
                        </div>
                    </div>
                );
            },
        },
        {
            title: '创建时间',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 170,
        },
        {
            title: '操作',
            key: 'action',
            width: 200,
            fixed: 'right',
            render: (_, record) => (
                <Space size={4}>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => handleViewDevice(record.license)}
                    >
                        查看设备
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => handleViewOwnership(record.license)}
                    >
                        归属变更历史
                    </Button>
                </Space>
            ),
        },
    );

    // ═══════════ 渲染 ═══════════

    return (
        <div style={{ padding: 24 }}>
            {/* 页面标题 */}
            <div style={{ marginBottom: 16 }}>
                <Title level={4}>License查询</Title>
            </div>

            {/* Alert 提示条 */}
            <Alert
                message="未使用平台产测工具的客户，License状态不存在「已生产」环节。如需连接License生命周期，后续可通过开放API上报License状态。"
                type="info"
                showIcon
                closable
                style={{ marginBottom: 24, borderRadius: 8 }}
            />

            {/* 筛选区 */}
            <Card
                bordered={false}
                style={{
                    marginBottom: 16,
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                }}
            >
                {/* 角色切换（原型演示） */}
                <div style={{ marginBottom: 16, background: '#f0f5ff', padding: '8px 16px', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>
                        <Text type="secondary" style={{ fontSize: 12 }}>原型演示：当前角色为 </Text>
                        <Text strong>{isPlatform ? '平台运营' : '设备制造商（企管）'}</Text>
                        <Text type="secondary" style={{ fontSize: 12, marginLeft: 8 }}>
                            （{isPlatform ? '全平台数据' : `企业: ${CURRENT_ENTERPRISE_ID}`}）
                        </Text>
                    </span>
                    <Button
                        size="small"
                        onClick={() => {
                            setIsPlatform(!isPlatform);
                            setDataSource([]);
                            setTotal(0);
                            setInitialLoaded(false);
                            form.resetFields();
                            setProductMode('name');
                            setPlanMode('name');
                            setOrderMode('name');
                            setEnterpriseMode('name');
                        }}
                    >
                        切换为{isPlatform ? '设备制造商' : '平台运营'}
                    </Button>
                </div>

                <Form
                    form={form}
                    layout="inline"
                    style={{ flexWrap: 'wrap', gap: 8 }}
                >
                    {/* License 查询 */}
                    <Form.Item name="license" style={{ marginBottom: 8 }}>
                        <Input
                            placeholder="请输入 License 码"
                            style={{ width: 200 }}
                            allowClear
                        />
                    </Form.Item>

                    {/* 所属企业（仅平台角色） */}
                    {isPlatform && (
                        <Form.Item name="enterpriseValue" style={{ marginBottom: 8 }}>
                            <Space.Compact>
                                <Select
                                    value={enterpriseMode}
                                    onChange={(val) => {
                                        setEnterpriseMode(val);
                                        form.setFieldValue('enterpriseValue', undefined);
                                        setEnterpriseOptions([]);
                                    }}
                                    style={{ width: 110 }}
                                >
                                    <Option value="name">企业名称</Option>
                                    <Option value="id">企业ID</Option>
                                </Select>
                                {enterpriseMode === 'name' ? (
                                    <Select
                                        showSearch
                                        placeholder="请搜索企业名称"
                                        style={{ width: 220 }}
                                        allowClear
                                        filterOption={false}
                                        onSearch={handleEnterpriseSearch}
                                        onFocus={() => handleEnterpriseSearch('')}
                                        notFoundContent={enterpriseSearching ? '搜索中...' : '暂无匹配结果'}
                                        options={enterpriseOptions}
                                    />
                                ) : (
                                    <Input
                                        placeholder="请输入企业ID"
                                        style={{ width: 220 }}
                                        allowClear
                                    />
                                )}
                            </Space.Compact>
                        </Form.Item>
                    )}

                    {/* 产品名称/ID */}
                    <Form.Item name="productValue" style={{ marginBottom: 8 }}>
                        <Space.Compact>
                            <Select
                                value={productMode}
                                onChange={(val) => {
                                    setProductMode(val);
                                    form.setFieldValue('productValue', undefined);
                                    setProductOptions([]);
                                }}
                                style={{ width: 110 }}
                            >
                                <Option value="name">整机产品</Option>
                                <Option value="id">产品ID</Option>
                            </Select>
                            {productMode === 'name' ? (
                                <Select
                                    showSearch
                                    placeholder="请搜索整机产品"
                                    style={{ width: 200 }}
                                    allowClear
                                    filterOption={false}
                                    onSearch={handleProductSearch}
                                    onFocus={() => handleProductSearch('')}
                                    notFoundContent={productSearching ? '搜索中...' : '暂无匹配结果'}
                                    options={productOptions}
                                />
                            ) : (
                                <Input
                                    placeholder="请输入产品ID"
                                    style={{ width: 200 }}
                                    allowClear
                                />
                            )}
                        </Space.Compact>
                    </Form.Item>

                    {/* 方案产品/ID */}
                    <Form.Item name="planValue" style={{ marginBottom: 8 }}>
                        <Space.Compact>
                            <Select
                                value={planMode}
                                onChange={(val) => {
                                    setPlanMode(val);
                                    form.setFieldValue('planValue', undefined);
                                }}
                                style={{ width: 110 }}
                            >
                                <Option value="name">方案产品</Option>
                                <Option value="id">方案ID</Option>
                            </Select>
                            <Input
                                placeholder={planMode === 'id' ? '请输入方案ID' : '请输入方案产品'}
                                style={{ width: 200 }}
                                allowClear
                            />
                        </Space.Compact>
                    </Form.Item>

                    {/* 工单名称/ID */}
                    <Form.Item name="orderValue" style={{ marginBottom: 8 }}>
                        <Space.Compact>
                            <Select
                                value={orderMode}
                                onChange={(val) => {
                                    setOrderMode(val);
                                    form.setFieldValue('orderValue', undefined);
                                    setOrderOptions([]);
                                }}
                                style={{ width: 110 }}
                            >
                                <Option value="name">工单名称</Option>
                                <Option value="id">工单ID</Option>
                            </Select>
                            {orderMode === 'name' ? (
                                <Select
                                    showSearch
                                    placeholder="请搜索工单名称"
                                    style={{ width: 200 }}
                                    allowClear
                                    filterOption={false}
                                    onSearch={handleOrderSearch}
                                    onFocus={() => handleOrderSearch('')}
                                    notFoundContent={orderSearching ? '搜索中...' : '暂无匹配结果'}
                                    options={orderOptions}
                                />
                            ) : (
                                <Input
                                    placeholder="请输入工单ID"
                                    style={{ width: 200 }}
                                    allowClear
                                />
                            )}
                        </Space.Compact>
                    </Form.Item>

                    {/* 操作按钮 */}
                    <Form.Item style={{ marginBottom: 8 }}>
                        <Space>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                loading={searchLoading}
                            >
                                查询
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            {/* 数据表格区 */}
            <Card
                bordered={false}
                style={{
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
                }}
            >
                {!initialLoaded ? (
                    // 首次加载骨架屏
                    <Skeleton active paragraph={{ rows: 10 }} />
                ) : searchLoading ? (
                    // 查询加载中
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        rowKey="license"
                        bordered={false}
                        size="middle"
                        loading={true}
                        pagination={false}
                        scroll={{ x: isPlatform ? 1300 : 1150 }}
                    />
                ) : dataSource.length > 0 ? (
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        rowKey="license"
                        bordered={false}
                        size="middle"
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total,
                            showSizeChanger: true,
                            showTotal: (t) => `共 ${t} 条记录`,
                            pageSizeOptions: ['20', '50', '100'],
                            onChange: handlePageChange,
                        }}
                        scroll={{ x: isPlatform ? 1300 : 1150 }}
                    />
                ) : (
                    <Empty
                        description={
                            total === 0 && !form.getFieldValue('license') &&
                            !form.getFieldValue('productValue') && !form.getFieldValue('orderValue')
                                ? '暂无 License 数据'
                                : '暂无符合条件的 License'
                        }
                        style={{ padding: '40px 0' }}
                    >
                        <Text type="secondary" style={{ fontSize: 13 }}>
                            {total === 0 && !form.getFieldValue('license') &&
                            !form.getFieldValue('productValue') && !form.getFieldValue('orderValue')
                                ? ''
                                : '请尝试修改筛选条件'}
                        </Text>
                    </Empty>
                )}
            </Card>

            {/* 归属变更历史抽屉 */}
            <Drawer
                title={`归属变更历史 - ${ownershipLicense}`}
                width={800}
                open={ownershipOpen}
                onClose={() => setOwnershipOpen(false)}
                destroyOnClose
            >
                {ownershipChain.length === 0 ? (
                    <Empty description="该 License 暂无归属变更记录" />
                ) : (
                    <Table
                        size="small"
                        rowKey={(r) => `${r.license}-${r.changedAt}`}
                        dataSource={ownershipChain}
                        pagination={false}
                        scroll={{ x: 900 }}
                        style={{ whiteSpace: 'nowrap' }}
                        columns={[
                            {
                                title: 'License',
                                dataIndex: 'license',
                                width: 200,
                                render: (text) => <Text style={{ fontFamily: 'monospace' }}>{text}</Text>,
                            },
                            {
                                title: '方案产品',
                                key: 'plan',
                                width: 180,
                                render: (_, r) => (
                                    <div>
                                        <div style={{ fontWeight: 500 }}>{r.planProductName}</div>
                                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.planProductId}</Text>
                                    </div>
                                ),
                            },
                            {
                                title: '整机产品',
                                key: 'machine',
                                width: 180,
                                render: (_, r) => (
                                    <div>
                                        <div style={{ fontWeight: 500 }}>{r.machineProductName}</div>
                                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.machineProductId}</Text>
                                    </div>
                                ),
                            },
                            {
                                title: '整机企业',
                                key: 'machineCompany',
                                width: 180,
                                render: (_, r) => (
                                    <div>
                                        <div style={{ fontWeight: 500 }}>{r.machineCompanyName}</div>
                                        <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.machineCompanyId}</Text>
                                    </div>
                                ),
                            },
                            { title: '变更时间', dataIndex: 'changedAt', width: 170 },
                            {
                                title: '来源',
                                key: 'source',
                                width: 220,
                                render: (_, r) => (
                                    r.sourceType === 'tool' ? (
                                        <div>
                                            <Tag color="blue" style={{ border: 'none' }}>产测工具</Tag>
                                            <div style={{ fontSize: 12 }}>{r.workOrderName}</div>
                                            <Text type="secondary" style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.workOrderId}</Text>
                                        </div>
                                    ) : (
                                        <div>
                                            <Tag color="green" style={{ border: 'none' }}>后台管理</Tag>
                                            <div style={{ fontSize: 12, fontFamily: 'monospace' }}>{r.operationNo}</div>
                                        </div>
                                    )
                                ),
                            },
                            {
                                title: '结果',
                                dataIndex: 'result',
                                width: 90,
                                render: (v, r) => (
                                    <Tag color={OWNERSHIP_RESULT_MAP[v]?.color} style={{ border: 'none' }} title={r.failReason || ''}>
                                        {OWNERSHIP_RESULT_MAP[v]?.text || v}
                                    </Tag>
                                ),
                            },
                        ]}
                    />
                )}
            </Drawer>
        </div>
    );
};

export default LicenseQueryNew;
